import { ReactElement } from "react";
import { Redirect, Route, Switch, useHistory } from "react-router-dom";
import { Button, Flex, Text } from "@jsq/ds/core";
import { globalEnv } from "~/global-env";
import { SPACING } from "~/styles/variables";
import { User } from "~/types/user";
import { getRedirectPath, isEnablementUser } from "~/utils/userRoles";
import { AnnouncementList } from "./AnnouncementList";
import CreateAnnouncementForm from "./CreateAnnouncementForm";

interface Props {
  currentUser: User;
}

export const Enablement = ({ currentUser }: Props): ReactElement => {
  const history = useHistory();

  if (!isEnablementUser(currentUser.roles)) {
    return <Redirect to={getRedirectPath(currentUser)} />;
  }

  const handleCreateAnnouncementClick = () => {
    history.push(`${globalEnv.enablementRoute}/create-announcement`);
  };

  return (
    <div
      css={{
        backgroundColor: "#fff",
        height: "calc(100vh - 60px)",
        padding: SPACING.LARGE,
      }}
    >
      <Flex
        style={{ marginBottom: SPACING.MEDIUM }}
        justifyContent="space-between"
        alignItems="center"
      >
        <Text variant="h2">In-app announcements</Text>

        <Button icon="plus" variant="primary" onClick={handleCreateAnnouncementClick}>
          Create new announcement
        </Button>
      </Flex>
      <Flex>
        <AnnouncementList />
      </Flex>
      <Switch>
        <Route path="/enablement/create-announcement">
          <CreateAnnouncementForm />
        </Route>
      </Switch>
    </div>
  );
};
